import "../../common/helpers/enumHelper"
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot } from "@angular/router";
import { Injectable } from "@angular/core";
import { StorageManager } from "../managers/storageManager";
import { AppFlags } from "../../objects/apps/app";

@Injectable()
export class AppGuard implements CanActivate, CanActivateChild {
    constructor(private storageManager: StorageManager, private router: Router) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> | boolean {
        return true;
        // if (this.storageManager.getCurrentAppId() <= 0) {
        //     this.router.navigate(['/apps']);
        //     return false;
        // }
        //
        // if (state.url == "/app/sip/subscriptions")
        //     return true;
        //
        // return this.storageManager.getCurrentUser().then(user => {
        //     if (user.Role.indexOf(1) > -1 || user.Role.indexOf(13) > -1) {
        //         if (state.url == "/app/sip")
        //             this.router.navigate(["/app/sip/brands"]);
        //         return true;
        //     }
        //
        //     if (!app.Flags.hasFlag(AppFlags.Paid)) {
        //         this.router.navigate(["/app/sip/subscriptions"]);
        //         return false;
        //     }
        //
        //     if (state.url == "/app/sip") {
        //         const groups = app.Groups.filter(group => group.UserIds.indexOf(user.Id) > -1);
        //
        //         if (groups.some(group => group.Type == GroupType.Owner)) {
        //             this.router.navigate(["/app/sip/brands"]);
        //             return false;
        //         } else {
        //             this.router.navigate(["/app/sip/marketshare"]);
        //             return false;
        //         }
        //     }
        //
        //     return true;
        // })
        //     .catch(x => {
        //         this.router.navigate(["/apps"]);
        //         return false;
        //     });
    }

    canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Promise<boolean> {
        return this.canActivate(childRoute, state);
    }
}


// WEBPACK FOOTER //
// ./app/common/guards/appGuard.ts